import { getCurrentIntl } from 'i18n/util/currentIntl'
import { formatOccupantsShort } from 'lib/offer/occupancyUtils'
import { pluralizeToString } from 'lib/string/pluralize'

export function getOccupancyText(rooms: Array<App.Occupants>, saleUnit?: string) {
  const intl = getCurrentIntl()
  let text = formatOccupantsShort(rooms)
  if (!!saleUnit && !!rooms.length) {
    text = intl.formatMessage(
      {
        id: 'cvqQxq3/Vu',
        defaultMessage: '{occupancyText} · {saleUnitLabel}',
        description: 'Recommendation occupancy text with sale unit count',
      },
      {
        occupancyText: text,
        saleUnitLabel: pluralizeToString(saleUnit, rooms.length),
      },
    )
  }
  return text
}

export function getBnblOccupancyText(numberOfRooms: number, saleUnit?: string) {
  if (!!saleUnit && !!numberOfRooms) {
    return pluralizeToString(saleUnit, numberOfRooms)
  }
}
